<div class="dfm" role="dialog" aria-modal="true" aria-labelledby="dfm-title" aria-describedby="dfm-desc">
  <div class="dfm__panel" [@modalPanel]="panel">

    <!-- Preparando proceso (antes de Entrust) -->
    <ng-container *ngIf="panel === 'preparing'">
      <div class="dfm__hero" aria-hidden="true">
        <div class="dfm__pulse-ring dfm__pulse-ring--soft"></div>
        <div class="dfm__graphic dfm__graphic--auth dfm__graphic--soft">
          <i class="fas fa-shield-halved"></i>
        </div>
      </div>
      <h2 class="dfm__title" id="dfm-title">Preparando tu firma</h2>
      <p class="dfm__text dfm__text--center" id="dfm-desc">
        Estamos listos para autenticar
        <strong *ngIf="fileName">{{ fileName }}</strong><span *ngIf="!fileName">tu documento</span>.
        <span class="dfm__text-soft">En un momento se abrirá la ventana de Certicámara.</span>
      </p>
      <div class="dfm__progress" aria-hidden="true">
        <span class="dfm__progress-bar"></span>
      </div>
      <div class="dfm__actions">
        <button type="button" class="dfm__btn dfm__btn--link" (click)="cancelar()">
          Cancelar
        </button>
      </div>
    </ng-container>

    <!-- Estado inicial (fallback) -->
    <ng-container *ngIf="panel === 'idle'">
      <div class="dfm__graphic dfm__graphic--auth" aria-hidden="true">
        <i class="fas fa-lock"></i>
      </div>
      <h2 class="dfm__title" id="dfm-title">Autenticación para firmar</h2>
      <p class="dfm__text" id="dfm-desc">
        Para continuar con la firma de <strong>{{ fileName }}</strong> debes iniciar sesión
        con tu cédula y contraseña en la ventana de Certicámara.
      </p>
      <div class="dfm__actions">
        <button type="button" class="dfm__btn dfm__btn--primary" (click)="iniciarSesion()" cdkFocusInitial>
          Iniciar sesión
        </button>
        <button type="button" class="dfm__btn dfm__btn--link" (click)="cancelar()">
          Cancelar
        </button>
      </div>
    </ng-container>

    <!-- Esperando autenticación externa -->
    <ng-container *ngIf="panel === 'waiting'">
      <div class="dfm__hero" aria-hidden="true">
        <div class="dfm__pulse-ring"></div>
        <div class="dfm__graphic dfm__graphic--auth dfm__graphic--soft">
          <i class="fas fa-lock"></i>
        </div>
      </div>
      <h2 class="dfm__title" id="dfm-title">Autenticación en curso</h2>
      <p class="dfm__text dfm__text--center" id="dfm-desc">
        Completa el inicio de sesión en la ventana de Certicámara.
        <span class="dfm__text-soft">Esta pantalla se actualizará sola.</span>
      </p>
      <div class="dfm__actions">
        <button type="button" class="dfm__btn dfm__btn--link" (click)="cancelar()">
          Cancelar
        </button>
      </div>
    </ng-container>

    <!-- Descargando / aplicando firma -->
    <ng-container *ngIf="panel === 'signing'">
      <div class="dfm__hero" aria-hidden="true">
        <div class="dfm__pulse-ring dfm__pulse-ring--success"></div>
        <div class="dfm__graphic dfm__graphic--success dfm__graphic--soft">
          <i class="fas fa-pen-nib"></i>
        </div>
      </div>
      <h2 class="dfm__title">Firmando documento</h2>
      <p class="dfm__text dfm__text--center">
        Autenticación lista. Estamos aplicando la firma a <strong>{{ fileName }}</strong>…
        <span class="dfm__text-soft">No cierres Certitool; te avisaremos al terminar.</span>
      </p>
    </ng-container>

    <!-- Éxito breve antes de cerrar -->
    <ng-container *ngIf="panel === 'success'">
      <div class="dfm__graphic dfm__graphic--success" aria-hidden="true">
        <i class="fas fa-check"></i>
      </div>
      <h2 class="dfm__title">Firma exitosa</h2>
      <p class="dfm__text dfm__text--center dfm__text--success">
        <strong>{{ fileName }}</strong> se firmó correctamente.
      </p>
    </ng-container>

    <!-- Ventana cerrada sin completar (proceso aún reanudable) -->
    <ng-container *ngIf="panel === 'incomplete'">
      <div class="dfm__graphic dfm__graphic--warn" aria-hidden="true">
        <i class="fas fa-exclamation-triangle"></i>
      </div>
      <h2 class="dfm__title">Autenticación incompleta</h2>
      <p class="dfm__text dfm__text--warn">
        La ventana de Certicámara se cerró antes de terminar. Puedes abrirla de nuevo
        para continuar, o cancelar el proceso.
      </p>
      <div class="dfm__actions">
        <button type="button" class="dfm__btn dfm__btn--primary" (click)="iniciarSesion()">
          Continuar autenticación
        </button>
        <button type="button" class="dfm__btn dfm__btn--link" (click)="cancelar()">
          Cancelar
        </button>
      </div>
    </ng-container>

    <!-- Error (proceso terminal: no reabrir el mismo processId) -->
    <ng-container *ngIf="panel === 'error'">
      <div class="dfm__graphic dfm__graphic--error" aria-hidden="true">
        <i class="fas fa-times-circle"></i>
      </div>
      <h2 class="dfm__title">No pudimos completar la firma</h2>
      <p class="dfm__text dfm__text--error">{{ mensajeError }}</p>
      <div class="dfm__actions">
        <button type="button" class="dfm__btn dfm__btn--primary" (click)="cerrarError()">
          Entendido
        </button>
      </div>
    </ng-container>
  </div>
</div>
